import React from "react";
import Image from "components/imageNew/image";
import { BreakfastPartnership } from "content-ui/breakfast/types";

type PartnershipBlockProps = BreakfastPartnership & {
  onClick?: () => void;
};

const PartnershipBlock = ({
  partnershipLabel,
  logo,
  url,
  onClick,
  name,
}: PartnershipBlockProps) => {
  const getImage = () => {
    return (
      <Image
        src={logo.url}
        alt={logo.alt || `${name} logo`}
        width={logo.width}
        height={logo.height}
        blurDataURL={logo.blurUpThumb}
        className={"pointer-events-none h-[42px] w-[105px] object-contain"}
        sizes={"250px"}
      />
    );
  };
  return (
    <div className={"flex flex-row items-center gap-2"}>
      <p className={"font-bold text-[14px] leading-[130%] text-mono-40"}>
        {partnershipLabel}
      </p>
      {url ? (
        <a
          href={url}
          target={"_blank"}
          rel="noreferrer"
          onClick={onClick}
          aria-label={`Link to ${name} website`}
        >
          {getImage()}
        </a>
      ) : (
        <div>{getImage()}</div>
      )}
    </div>
  );
};

export default PartnershipBlock;
